<template>
	<div class="cooperationProgress main-content-padding">
		<Panel :contentPaddingTop="12">
			<platformTab @change="pfHandleClick" :showAll="true" :platformId="platformId" />
			<SubTabs @tab-click="handleClick" v-model="tabName" :list="tableArr">
				<template slot-scope="{ item }">
					<div>
						<span>{{ item.label }}</span>
						<span class="ml-4">{{ item.count }}</span>
					</div>
				</template>
			</SubTabs>
			<search
				:tabName="tabName"
				:delivery_status="delivery_status"
				:platformId="platformId"
				ref="search"
				@onSubmit="onSubmit"
				:sampleAudit="sampleAudit"
			></search>
		</Panel>
		<Panel>
			<div class="flex-row flex-just-between align-center">
				<div class="flex flex-align-center">
					<ButtonGroup :paddingLeft="0" v-if="!isWaitLiveTable">
						<el-checkbox :indeterminate="isIndeterminate" @change="checkeAll" v-model="allChecked">当页全选</el-checkbox>
					</ButtonGroup>
					<ButtonGroup :lineHeight="8">
						<!-- 选品表按钮 -->
						<!-- <template v-if="isSelectionTable">
							<el-tooltip content="请先选择商品" :disabled="!!selectionShopArr.length" placement="top">
								<el-button v-if="$auth.hasPermi('system:cooperationProgress:selection:Remove')" @click="batchDel">批量移除商品</el-button>
							</el-tooltip>
							<el-button
								v-if="$auth.hasPermi('system:cooperationProgress:selection:export')"
								@click="exportTableWidthLimit"
								:loading="exportBtnLoading"
								>导出</el-button
							>
						</template> -->

						<!-- 申样表按钮 -->
						<template v-if="isSampleTable">
							<el-button v-if="$auth.hasPermi('system:cooperationProgress:sample:export')" @click="exportSampleTable" :loading="exportBtnLoading">
								导出
							</el-button>
							<el-button v-if="$auth.hasPermi('system:cooperationProgress-record:query')" @click="exportSampleList">导出记录</el-button>
						</template>

						<!-- 待播表按钮 -->
						<template v-else-if="isWaitLiveTable">
							<el-button v-if="$auth.hasPermi('system:cooperationProgress:Waiting:export')" @click="exportTable" :loading="exportBtnLoading">
								导出
							</el-button>
							<el-tooltip content="已录入过达人档期" placement="top" key="1">
								<div class="ml-24">
									<el-checkbox class="cooperationProgress_list_checkbox" v-model="schedule" @change="checkSearch" :true-label="1" :false-label="0">
										<span class="yx-pingfang-regular font-h6-regular">达人已跟进</span>
										<i class="el-icon-question ml-2"></i>
									</el-checkbox>
								</div>
							</el-tooltip>
							<el-tooltip content="未录入过达人档期" placement="top" key="2">
								<div class="ml-24">
									<el-checkbox class="cooperationProgress_list_checkbox" v-model="noSchedule" @change="checkSearch" :true-label="1" :false-label="0">
										<span class="yx-pingfang-regular font-h6-regular">达人未跟进</span>
										<i class="el-icon-question ml-2"></i>
									</el-checkbox>
								</div>
							</el-tooltip>
						</template>

						<!-- 开播表按钮 -->
						<template v-else>
							<el-button
								v-if="$auth.hasPermi('system:cooperationProgress:broadcast:export')"
								@click="exportTableWidthLimit"
								:loading="exportBtnLoading"
							>
								导出
							</el-button>
							<el-tooltip content="已录入过达人档期" placement="top" key="3">
								<div class="ml-24">
									<el-checkbox class="cooperationProgress_list_checkbox" v-model="schedule" @change="checkSearch" :true-label="1" :false-label="0">
										<span class="yx-pingfang-regular font-h6-regular">达人已跟进</span>
										<i class="el-icon-question ml-2"></i>
									</el-checkbox>
								</div>
							</el-tooltip>
							<el-tooltip content="未录入过达人档期" placement="top" key="4">
								<div class="ml-24">
									<el-checkbox class="cooperationProgress_list_checkbox" v-model="noSchedule" @change="checkSearch" :true-label="1" :false-label="0">
										<span class="yx-pingfang-regular font-h6-regular">达人未跟进</span>
										<i class="el-icon-question ml-2"></i>
									</el-checkbox>
								</div>
							</el-tooltip>
						</template>
					</ButtonGroup>
					<ButtonGroup :lineHeight="8" v-if="isSampleTable">
						<el-checkbox @change="seeNotContact" v-model="notContact" class="mr-10">仅查看未联系商家</el-checkbox>
					</ButtonGroup>
				</div>
			</div>
		</Panel>
		<div v-loading="loading">
			<CardList ref="cardList" @changeData="changeData" :selectedList="selectionShopArr" @checkedItemFn="checkedItemFn" :list="list" />
			<bottomfixed>
				<yx-pagination
					:total="total"
					:current-page="pageInfo.page_index"
					:page-size="pageInfo.page_size"
					@size-change="sizeChange"
					@current-change="currentChange"
					class="yx-background-white"
				></yx-pagination>
			</bottomfixed>
		</div>
		<empty v-if="!list.length && !loading" :isSearch="true" ref="empty" slot="empty" />

		<!-- 编辑商品 -->
		<editProduct ref="editProduct" @refreshList="refreshList" />

		<!-- 更换链接 -->
		<replaceLink ref="replaceLink" @refreshList="refreshList" />

		<!-- 查看合作数据 -->
		<cooperData ref="cooperData" @refreshList="refreshList" />

		<!-- 拒绝带货理由 -->
		<refuse ref="refuse" @refreshList="refreshList" />

		<!-- 拒绝带发货原因 -->
		<reason ref="reason" @refreshList="refreshList" />

		<!-- 申请样品 -->
		<apply ref="apply" @refreshList="refreshList" />

		<!-- 确认商品机制的变更 -->
		<change ref="change" @refreshList="refreshList" />

		<!-- 多功能弹框 -->
		<multi ref="multi" @refreshList="refreshList" />

		<!-- 确认开播 -->
		<begin ref="begin" @refreshList="refreshList" />

		<!-- 导出订单 -->
		<exportData ref="exportData" @refreshList="refreshList" />

		<!-- 确认商品机制的变更 -->
		<changeDetails ref="changeDetails" @refreshList="refreshList" />

		<!-- 查看手卡 -->
		<handCardDialog ref="handCardDialog" />

		<!-- 达人详情 -->
		<detail-drawer ref="detailDrawer" @getList="refreshList" />

		<!-- 短视频数据 -->
		<short-video ref="shortVideo" @getList="refreshList" />

		<!-- 补寄样品申请 -->
		<reissue-drawer ref="reissueDrawer" :tabName="tabName" @getList="refreshList" />

		<!-- 导出提示 -->
		<exportTips ref="exportTips" @exportTable="exportTable" />

		<!-- 导出提示 -->
		<editBeginTime ref="editBeginTime" @refreshList="refreshList" />

		<!-- 更新达人档期 -->
		<starSchedule ref="starSchedule" @refreshList="refreshList" />
	</div>
</template>
<script>
import ButtonGroup from '@/components/ui/buttonGroup';
import CardList from './components/cardList';

// 旧版本分割线
import throttle from 'lodash/throttle';
import mixin from './mixin';
import { getButtons } from './buttons';
import search from './components/search.vue';
import starSchedule from './components/dialog/starSchedule.vue';
import editProduct from './components/dialog/editProduct.vue';
import replaceLink from './components/dialog/replaceLink.vue';
import cooperData from './components/dialog/cooperData.vue';
import refuse from './components/dialog/refuse.vue';
import reason from './components/dialog/reason.vue';
import apply from './components/dialog/apply.vue';
import change from './components/dialog/change.vue';
import multi from './components/dialog/multi.vue';
import begin from './components/dialog/begin.vue';
import exportData from './components/dialog/export.vue';
import changeDetails from './components/dialog/changeDetails.vue';
import reissueDrawer from './components/reissueDrawer';
import editBeginTime from './components/dialog/editBeginTime';
import detailDrawer from '@/views/talentCRM/components/detailDrawer';
import {
	OrderList,
	anchorProduct,
	waitingList,
	liveList,
	homeStat,
	stopCooperation,
	reCooperation,
	delCooperation,
	batchDel,
} from '@/api/cooperationProgress';
import { getAuditConf } from '@/api/sampleOrder';
import handCardDialog from '@/views/shopManage/components/handCardDialog.vue';
import shortVideo from './components/dialog/shortVideo.vue';
import empty from '@/views/common/empty/index.vue';
import { exportSampleList, exportSelection, exportTobe, liveExport } from '@/api/cooperationProgress';
import { debounce } from 'lodash';
import exportTips from './components/dialog/exportTips.vue';
import { shopCooperationStatus } from '@/api/cooperativeShop';
import { platformMixin } from '@rd/rd-ui';
import { mapGetters } from 'vuex';
import { AUDIT_STATUS_CLOSE } from '@/utils/dataMap';
import bottomfixed from '@/components/ui/bottomFixed/bottomFixed.vue';
import SubTabs from '@/components/ui/subTabs/index.vue';
export default {
	name: 'cooperationProgress',
	components: {
		ButtonGroup,
		CardList,
		editProduct,
		search,
		starSchedule,
		replaceLink,
		cooperData,
		refuse,
		apply,
		change,
		multi,
		begin,
		changeDetails,
		handCardDialog,
		exportData,
		reason,
		detailDrawer,
		shortVideo,
		reissueDrawer,
		empty,
		exportTips,
		editBeginTime,
		bottomfixed,
		SubTabs,
	},
	provide() {
		return {
			injectIsSampleOrder: this.sampleOrder,
			injectCooperationStatus: () => this.cooperationStatus,
			replaceLinkFun: (row, title) => this.replaceLinkFun(row, row.tabName, title),
			settingBeginTime: row => this.settingBeginTime(row),
			injectShowDetailDrawer: row => this.showDetailDrawer(row),
		};
	},
	mixins: [mixin, platformMixin],
	data() {
		return {
			tabName: '1',
			tableArr: [
				// { label: '待选品', name: '0' },
				{ label: '待寄样', name: '1' },
				{ label: '待交付', name: '2' },
				{ label: '已交付', name: '3' },
			],
			list: [],
			selectionShopArr: [],
			params: {},
			pageInfo: {
				page_index: 1,
				page_size: 10,
			},
			total: '0',
			allChecked: false,
			loading: false,
			exportBtnLoading: false,
			delivery_status: '',
			cooperate_id: '',
			cooperation: true,
			notContact: false,
			contact_status: undefined,
			sampleOrder: false,
			sampleAudit: AUDIT_STATUS_CLOSE,
			isSyncVideo: false,
			cooperationStatus: false,
			platformId: '',
			isIndeterminate: false,
			// 在混入中被使用，更改默认的平台id
			defaultAllPlatformId: dataMap.PLATFORM_ALL.value,
			schedule: 0,
			noSchedule: 0,
		};
	},
	computed: {
		...mapGetters(['canShowPlatformList']),
		isSelectionTable() {
			return this.tabName === '0';
		},
		isSampleTable() {
			return this.tabName === '1';
		},
		isWaitLiveTable() {
			return this.tabName === '2';
		},
		isStartLiveTable() {
			return this.tabName === '3';
		},
		selectedLength() {
			return this.selectionShopArr.length;
		},
	},
	created() {
		let { tabid = '1', delivery_status = '', cooperate_id = '' } = this.$route.query;
		this.tabName = tabid || '1';
		this.params.delivery_status = delivery_status;
		this.params.cooperate_id = cooperate_id;
		this.getAudit();
		this.getCooperationStatus();
		this.homeFun();
		this.getProductList();
	},
	methods: {
		handleStarScheduleShow(info) {
			this.$refs['starSchedule'].show(info);
		},
		checkSearch(e) {
			this.pageInfo.page_index = 1;
			this.refreshList();
			//刷新列表
		},
		pfHandleClick(val) {
			this.platformId = val;
			this.homeFun();
			this.$refs.search.onClear();
			this.getProductList();
		},
		//全选
		checkeAll(val) {
			this.selectionShopArr = val ? this.list : [];
			this.changeData('isIndeterminate', false);
		},
		// 用于变更全选状态
		changeData(key, value) {
			this[key] = value;
		},
		// 得到选中的列表
		checkedItemFn(val) {
			this.selectionShopArr = val;
		},

		// 旧版本分割线
		//获取列表数据
		async getProductList() {
			this.params.contact_status = this.contact_status;
			//选品表
			this.loading = true;
			const apis = [anchorProduct, OrderList, waitingList, liveList];
			const allChecked = !!(this.schedule && this.noSchedule); //全勾选
			const allNoChecked = !this.schedule && !this.noSchedule; //全不勾选
			const is_schedule = allChecked || allNoChecked ? -1 : this.schedule ? this.schedule : this.noSchedule ? 0 : -1;

			const {
				code,
				data: { page, list, product_list, isSyncVideo = false },
			} = await apis[this.tabName]({
				platform_id: this.platformId,
				...this.params,
				...this.pageInfo,
				is_schedule,
			});
			this.loading = false;
			if (code === 0) {
				const _list = this.isSampleTable ? list : product_list;
				this.total = `${page.item_total}`;
				this.isSyncVideo = isSyncVideo;
				this.list = _list.map(item => ({
					...item,
					tabName: this.tabName,
					operations: getButtons(this, item),
				}));
			}
		},
		async homeFun() {
			const data = await homeStat({ platform_id: this.platformId });
			let arr = Object.values(data);
			this.tableArr = this.tableArr.map((item, index) => {
				return {
					...item,
					...arr[index],
				};
			});
		},
		handleClick() {
			this.resetSelect();
			this.$refs.search.onClear();
			this.homeFun();
		},
		//分页
		sizeChange(val) {
			this.resetSelect();
			this.pageInfo.page_size = val;
			this.getProductList();
		},
		currentChange(val) {
			this.resetSelect();
			this.pageInfo.page_index = val;
			this.getProductList();
		},
		//筛选
		onSubmit(val) {
			this.resetSelect();
			if (this.$isAllPF(this.platformId) && val.anchor_platformId) {
				val.platform_id = val.anchor_platformId;
				//查询条件优先取这里的id，没有再取this.platformId
			}
			if (this.$isAllPF(this.platformId) && val.anchor_platformId && this.$isSp(val.anchor_platformId)) {
				val.anchor_uid = val.anchor_account;
				delete val.anchor_account;
				val.platform_id = val.anchor_platformId;
			}

			if (this.$isSp(this.platformId)) {
				//视频号
				val.anchor_uid = val.anchor_account;
				delete val.anchor_account;
			}
			delete val.anchor_platformId;

			this.params = val;
			this.pageInfo.page_index = 1;
			this.getProductList();
		},
		resetSelect() {
			this.selectionShopArr = [];
			this.allChecked = false;
			this.changeData('isIndeterminate', false);
		},
		//导出表
		exportSampleTable() {
			this.$refs.exportTips.show();
		},
		exportSampleList() {
			const { href } = this.$router.resolve({ path: '/cooperationProgress/record', query: { action_type: 'sample_order_export' } });
			window.open(href, '_blank');
		},

		exportTable: debounce(async function () {
			this.exportBtnLoading = true;
			const apis = {
				0: exportSelection,
				1: exportSampleList,
				2: exportTobe,
				3: liveExport,
			};
			let row = {};
			if (this.selectionShopArr.length) {
				row.sample_sn = this.selectionShopArr.map(item => item.sample_sn).join(',');
			} else {
				row = { platform_id: this.platformId, ...this.params, ...this.pageInfo };
			}
			const params = {
				0: {}, //待选品
				1: row, //待寄样
				2: row, //待交付
				3: {}, //已交付
			};
			try {
				const { download_url } = await apis[this.tabName](params[this.tabName]);
				if (this.tabName == 1) {
					this.$message.success('导出成功！请在前往导出记录下载');
				} else {
					window.open(download_url, '_blank');
				}
			} catch (error) {
				if (error.code === -1) {
					this.$message.error(error.message);
				}
			} finally {
				this.exportBtnLoading = false;
			}
		}, 300),
		//导出表-带限制
		async exportTableWidthLimit() {
			if (!this.selectionShopArr.length) {
				this.$message.warning('请先勾选合作进度');
				return;
			}
			let cooperate_ids = this.selectionShopArr.map(item => item.cooperate_id).join(',');
			this.$refs.exportData.initExprot(cooperate_ids, this.tabName, this.selectedLength);
		},
		//刷新列表
		refreshList() {
			this.resetSelect();
			this.getProductList();
			this.homeFun();
		},
		async stopCooperation({ cooperate_id }) {
			try {
				await this.$confirm('停止合作后，该商品的合作信息保留，手动移除商品后才可以再次将该商品加入该达人的选品表。', '停止合作');
				const { code } = await stopCooperation({ cooperate_id });
				if (code !== 0) return;
				this.$message.success('停止合作成功');
				this.refreshList();
			} catch (error) {}
		},
		reCooperation: throttle(async function ({ cooperate_id }) {
			const { code } = await reCooperation({ cooperate_id });
			if (code !== 0) return;
			this.$message.success('操作成功');
			this.refreshList();
		}, 1000),
		async delCooperation({ cooperate_id }) {
			try {
				await this.$confirm('移除商品后，可以将商品加入该达人的选品表，重新进行合作', '移除商品');
				const { code } = await delCooperation({ cooperate_id });
				if (code !== 0) return;
				this.$message.success('移除商品成功');
				this.refreshList();
			} catch (error) {}
		},
		showDetailDrawer({ anchor_id }) {
			this.$refs.detailDrawer.show(anchor_id);
		},
		showReissueDrawer(row) {
			this.$refs.reissueDrawer.show(row);
		},
		settingBeginTime(row) {
			this.$refs.editBeginTime.show(row);
		},
		seeNotContact(e) {
			this.resetSelect();
			this.contact_status = e ? '0' : undefined;
			this.getProductList();
		},
		batchDel() {
			if (!this.selectionShopArr.length) return;
			let cooperate_ids = this.selectionShopArr.map(item => item.cooperate_id).join(',');
			this.$confirm(`共计 ${this.selectionShopArr.length} 个商品, 是否继续?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(async () => {
				const { code } = await batchDel({ cooperate_ids });
				if (code !== 0) return;
				this.getProductList();
				this.resetSelect();
				this.$message({
					type: 'success',
					message: '删除成功!',
				});
			});
		},
		async getAudit() {
			const { sampleAudit = AUDIT_STATUS_CLOSE } = await getAuditConf({});
			this.sampleAudit = sampleAudit;
		},
		async getCooperationStatus() {
			const { cooperationStatus = false } = await shopCooperationStatus();
			this.cooperationStatus = cooperationStatus;
		},
	},
};
</script>
<style lang="less" scoped>
.cooperationProgress {
	margin-bottom: 70px;
}
.yx-background-white {
	position: absolute !important;
	right: 12px !important;
}
</style>
